import { render, staticRenderFns } from "./SchoolAccessRecord.vue?vue&type=template&id=0a86954c&scoped=true&"
import script from "./SchoolAccessRecord.vue?vue&type=script&lang=js&"
export * from "./SchoolAccessRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a86954c",
  null
  
)

export default component.exports